import { Header } from "semantic-ui-react";

import React from "react";

import Flex from "../../../../../components/Flex/Flex";
import useArticleTypeTranslations from "../../../../articles/hooks/useArticleTypeTranslations";
import CoverImage from "../../../../ui/components/CoverImage/CoverImage";
import truncateString from "../../../../ui/utils/truncateString";

export default function QuickSearchItemArticle({ item, showPublisher }) {
	const articleTypeTranslations = useArticleTypeTranslations();

	return (
		<Flex justifyContent="flex-start">
			<div style={{ marginRight: "1em", height: 40, width: 40 }}>
				<CoverImage thumb rounded data={item} size={40} style={{ margin: "0 auto" }} />
			</div>

			<Header as="h5" style={{ margin: 0 }}>
				{truncateString(item.name, 50)} {item.episodeName && ` - ${item.episodeName}`}
				<Header.Subheader>
					{showPublisher && `${item.publisher.name} - `}
					{articleTypeTranslations[item.type]} ({item.isbn})
				</Header.Subheader>
			</Header>
		</Flex>
	);
}
